
import Vue from 'vue'
import { mapState } from 'vuex'
import { formatDisplayDate } from '@/util/formatters'
import { JcdcLabeledText } from '@/components/jcdc/index'

export default Vue.extend({
  components: {
    JcdcLabeledText,
  },
  computed: {
    ...mapState('evaluations', ['strengthsBarriers']),
  },
  methods: {
    formatDisplayDate,
    formatDetails(item) {
      let modified
      if (item.lastModUser) {
        modified = {
          Modified: {
            By: item.lastModUser,
            Date: this.formatDisplayDate(item.lastModDt),
          },
        }
      }
      return {
        Type: item.typeDesc,
        Category: item.categoryDesc,
        Added: {
          By: item.addUser,
          Date: this.formatDisplayDate(item.addDt),
        },
        ...modified,
      }
    },
  },
})
